<script>
import ClearSelectionButton from './ClearSelectionButton.vue';
// ReportsFiltersTeams.vue
import { mapGetters } from 'vuex';

export default {
  name: 'ReportsFiltersTeams',
  components: { ClearSelectionButton },
  props: {
    selectFirstOption: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['teamFilterSelection'],
  data() {
    return {
      selectedOption: null,
      hasAutoSelected: false,
    };
  },
  computed: {
    ...mapGetters({
      options: 'teams/getTeams',
    }),
  },
  watch: {
    options: {
      handler(newOptions) {
        // Auto-seleciona o primeiro time quando os dados são carregados
        if (
          this.selectFirstOption &&
          !this.hasAutoSelected &&
          newOptions &&
          newOptions.length > 0
        ) {
          this.selectedOption = newOptions[0];
          this.hasAutoSelected = true;
          this.$emit('teamFilterSelection', this.selectedOption);
        }
      },
      immediate: false,
    },
  },
  mounted() {
    this.$store.dispatch('teams/get');
    // 🔥 NOVO: Se já tiver opções carregadas e deve auto-selecionar
    if (
      this.selectFirstOption &&
      !this.hasAutoSelected &&
      this.options &&
      this.options.length > 0
    ) {
      this.selectedOption = this.options[0];
      this.hasAutoSelected = true;
      this.$emit('teamFilterSelection', this.selectedOption);
    }
  },
  methods: {
    clearSelection() {
      this.selectedOption = null;
      this.handleInput();
    },
    handleInput() {
      this.$emit('teamFilterSelection', this.selectedOption);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      :placeholder="$t('TEAM_REPORTS.FILTER_DROPDOWN_LABEL')"
      label="name"
      track-by="id"
      :options="options"
      :option-height="24"
      :show-labels="false"
      @update:model-value="handleInput"
    >
      <template #clear>
        <ClearSelectionButton v-if="selectedOption" @clear="clearSelection" />
      </template>
    </multiselect>
  </div>
</template>
